import { Component, Directive, OnInit, ElementRef } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { AuthenticationService } from '../../auth.service';
import { config } from '../../../config/config';
import { mescUrl } from '../../../config/config.base';
import { utilities } from '../../../modules/utility';

@Component({
  selector: 'mesc',
  templateUrl: './mesc.component.html',
  // styles: ['./mesc.component.scss'],
  host: { 'class': 'router-outlet' },
})
export class MESCComponent implements OnInit {
  isLocal: boolean;

  constructor(
    public router: Router,
    private authService: AuthenticationService
  ) { }

  ngOnInit() { 
    this.isLocal = window.location.hostname.includes('localhost');
    this.redirectMescRoute();
    this.router.events.subscribe(() =>{
      this.redirectMescRoute();
    })
  }

  validatePath(path: string): boolean {
    return this.authService.isClaimValid(path);
  }

  redirectMescRoute() {
    if(!this.isLocal && this.router.url === '/MESC'){
      window.location.href = mescUrl[utilities.getEnv()]; //point to Mesc2 Landing page for deployed environment.
    }
  }
}
